import React, { useState } from "react";
import OrganizationChart from "@dabeng/react-orgchart";
import OrbatNode from "components/event/OrbatNode";
import styled from "styled-components";
import Tab from "@material-ui/core/Tab";
import Tabs from "components/common/Tabs";
import TabPanel from "components/common/TabPanel";

const OrbatChart = ({ sides = [] }) => {
  const [value, setValue] = useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  if (!Array.isArray(sides)) {
    return <div>Error: no sides could be found</div>;
  }

  return (
    <StyledWrapper>
      <Tabs
        value={value}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {sides.map(({ side }) => (
          <Tab key={side} label={`${side}`} />
        ))}
      </Tabs>
      {sides.map(({ groups = [], side }, index) => {
        if (!Array.isArray(groups)) {
          return <></>;
        }
        return (
          <TabPanel value={value} index={index} key={index}>
            <SideWrapper sideColor={getSideColor(side)} key={side}>
              {groups.map((i, idx) => (
                <div key={idx + i.side}>
                  <OrganizationChart
                    datasource={i}
                    chartClass="orbat"
                    NodeTemplate={(i) => OrbatNode({ item: i, side: side })}
                  />
                </div>
              ))}
            </SideWrapper>
          </TabPanel>
        );
      })}
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .MuiTab-textColorPrimary {
    color: grey;
  }
  .MuiTab-textColorPrimary.Mui-selected {
    color: white;
  }
  .MuiTouchRipple-root {
    border-style: solid;
    border-color: #3b618ccc;
    border-radius: 8px;
    border-width: 2px;
    padding: 5px;
    margin-left: 10px;
  }
`;

function getSideColor(side) {
  switch (side) {
    case "BLU":
      return "#3b618cCC";
    case "RED":
      return "#8C1B16CC";
    case "IND":
      return "#168C3FCC";
    //todo add civ side
    default:
      return "#3b618cCC";
  }
}

const SideWrapper = styled.div`
  .orgchart-container {
    border: solid 2px;
    border-color: ${(props) => props.sideColor};
    background-color: #2f3136;
    height: auto;
  }

  .orgchart {
    background-color: #2f3136;
    padding: 10px 10px 0 10px;
  }

  .orgchart.orbat {
    background-image: none;
  }

  .orgchart ul li .oc-node:not(:only-child)::after {
    background-color: ${(props) => props.sideColor};
  }

  .orgchart > ul > li > ul li > .oc-node::before {
    background-color: ${(props) => props.sideColor};
  }

  .orgchart > ul > li > ul li::before {
    border-top: 2px solid ${(props) => props.sideColor};
  }

  .orgchart ul li .oc-node.selected {
    background-color: #d3d3d466;
  }

  .orgchart ul li .oc-node:hover {
    background-color: #d3d3d466;
  }

  .orgchart .oc-node .oc-edge::before {
    border-color: #d3d3d4;
  }

  .oc-node {
    > div {
      border-color: ${(props) => props.sideColor};
    }
  }
`;

export default OrbatChart;
